import API from '../../../../../global/api';

export const getFirstData = () => {
    return (dispatch) => {
      API.get(`fl_130/get-appearance-respondent`, {
        headers: {
          /*Authorization: `Bearer ${window.localStorage.getItem("auth_id")}`,*/
        },
      }).then((res) => {
        let data = [];
        data = res.data;
        dispatch(successGetFirstData(data));
      });
    };
  };
  


export const requestGetFirstData = (data) =>{
    return {
        type: "REQUEST_GET_FIRST_DATA",
    }
}

export const successGetFirstData = (data) =>{
    return {
        type: "SUCCESS_GET_FIRST_DATA",
        payload: data,
    }
}

export const errorGetFirstData = (data)=>{
    return {
        type: "ERROR_GET_FIRST_DATA",
        payload: data,
    }
}






export const getSecondData = () => {
    return (dispatch) => {
      API.get(`fl_130/get-agreement-stipulation-waivers`, {
        headers: {
          /*Authorization: `Bearer ${window.localStorage.getItem("auth_id")}`,*/
        },
      }).then((res) => {
        let data = [];
        data = res.data;
        dispatch(successGetSecondData(data));
      });
    };
  };
  

export const requestGetSecondData = (data) =>{
    return {
        type: "REQUEST_GET_SECOND_DATA",
    }
}

export const successGetSecondData = (data) =>{
    return {
        type: "SUCCESS_GET_SECOND_DATA",
        payload: data,
    }
}

export const errorGetSecondData = (data)=>{
    return {
        type: "ERROR_GET_SECOND_DATA",
        payload: data,
    }
}



export const postAllData=(data)=>{
    return(dispatch)=>{
        API.put(`fl_130/update-fl-130`, data).then((res)=>{
            dispatch(successPostAllData(data));
        })  
    }    
}

export const requestPostAllData = () =>{
    return {
        type: "REQUEST_POST_ALL_DATA",       
    }
}
export const successPostAllData=(data)=>{
    return{
        type:"SUCCESS_POST_ALL_DATA",
        payload: data,
    }
}
export const errorPostAllData = (data)=>{
    return{
        type: "ERROR_POST_ALL_DATA",
        payload: data,
    }
}



export const postFirst=(data)=>{
    return(dispatch)=>{
        API.post(`fl_130/add-fl_130`, data).then((res)=>{
            dispatch(successPostFirst(data));
        })  
    }    
}

export const requestPostFirst = () =>{
    return {
        type: "REQUEST_POST_FIRST",       
    }
}
export const successPostFirst=(data)=>{
    return{
        type:"SUCCESS_POST_FIRST",
        payload: data,
    }
}
export const errorPostFirst = (data)=>{
    return{
        type: "ERROR_POST_FIRST",
        payload: data,
    }
}



export const getAllData = (data) =>{
    return (dispatch)=>{
      dispatch(requestGetAllData(data))
      API.post(`/fl_130/get-all-data`,{
        divore_id: window.localStorage.getItem("divorce_id"),
      }).then((res)=>{
        let data = [];
        data = res.data;
        dispatch(successGetAllData(data))
      });
    };
  };
  
  // Actions
  
  export const requestGetAllData = () =>{
    return{
      type: "REQUEST_GET_ALL_DATA"
    }
  }
  
  export const successGetAllData = (data) =>{
    return{
      type: "SUCCESS_GET_ALL_DATA",
      payload: data,
    }
  }
  
  export const errorGetAllData = (data) =>{
    return{
      type: "ERROR_GET_ALL_DATA",
      payload: data,
    }
  }